const styles = ({ COLORS }) => ({
  button: {
    margin: '0 2px',
    textDecoration: 'none'
  },
  action: {
    textAlign: 'right'
  },
  plainLink: {
    textDecoration: 'none',
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL
  },
  center: {
    textAlign: 'center'
  }
})

export default styles
